/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Player from './Player';
var SubstanceIBLPlayer = /** @class */ (function (_super) {
    __extends(SubstanceIBLPlayer, _super);
    function SubstanceIBLPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SubstanceIBLPlayer.prototype, "isEnabled", {
        get: function () {
            return this.config.RTE_VIEWER_ENABLED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubstanceIBLPlayer.prototype, "isSupported", {
        get: function () {
            return this.isWebGl2Supported();
        },
        enumerable: false,
        configurable: true
    });
    SubstanceIBLPlayer.prototype.getPlayerUrl = function () {
        return this.config.RTE_VIEWER_URL + "/ibl/" + this.config.CDN_ASSET_PREFIX + ":" + this.asset.id;
    };
    return SubstanceIBLPlayer;
}(Player));
export default SubstanceIBLPlayer;
